import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import "../../../assets/topstudio/styles/Player.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import axiosInstance from "../../../utils/axiosInstance";
import Volume from "./Volume";
import CasinoWarResult from "../../client/tp-studio/tp-result/CasinoWarResult.jsx";
import { isMobile } from "react-device-detect";
import CasinoWRules from "./pop-up/casinoW-rules.jsx";

import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";

export default function CasinoWar() {
  const dispatch = useDispatch();
  const [stakeLimit, setStakeLimit] = useState(0);
  const [showRules, setShowRules] = useState(false);
  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [displayLoader, setDisplayLoader] = useState(true);
  const [activeTabIndex, setActiveTabIndex] = useState(1);

  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [open, setOpen] = useState(false);

  const [card1Value, setCard1Value] = useState(1);
  const [card2Value, setCard2Value] = useState(1);
  const [card3Value, setCard3Value] = useState(1);
  const [card4Value, setCard4Value] = useState(1);
  const [card5Value, setCard5Value] = useState(1);
  const [card6Value, setCard6Value] = useState(1);
  const [card7Value, setCard7Value] = useState(1);

  const [card1Winner, setCard1Winner] = useState(false);
  const [card2Winner, setCard2Winner] = useState(false);
  const [card3Winner, setCard3Winner] = useState(false);
  const [card4Winner, setCard4Winner] = useState(false);
  const [card5Winner, setCard5Winner] = useState(false);
  const [card6Winner, setCard6Winner] = useState(false);

  const [card1Book, setCard1Book] = useState({ back: 0, lay: 0 });
  const [card2Book, setCard2Book] = useState({ back: 0, lay: 0 });
  const [card3Book, setCard3Book] = useState({ back: 0, lay: 0 });
  const [card4Book, setCard4Book] = useState({ back: 0, lay: 0 });
  const [card5Book, setCard5Book] = useState({ back: 0, lay: 0 });
  const [card6Book, setCard6Book] = useState({ back: 0, lay: 0 });

  const [b1Val, setB1Val] = useState(0);
  const [b2Val, setB2Val] = useState(0);
  const [b3Val, setB3Val] = useState(0);
  const [b4Val, setB4Val] = useState(0);
  const [b5Val, setB5Val] = useState(0);
  const [b6Val, setB6Val] = useState(0);
  const [roundId, setRoundId] = useState(0);
  const [cardDesc, setCardDesc] = useState("");
  const [resultDesc, setResultDesc] = useState("");
  const [result, setResult] = useState("");
  const [resultList, setResultList] = useState([]);
  const [resultData, setResultData] = useState([]);
  const [lastStatus, setLastStatus] = useState(null);

  /* ================= TIMER ================= */
  const TOTAL_SECONDS = 30;
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const localTimerRef = useRef(null);

  /* ================= SEQUENTIAL CARD REVEAL ================= */
  const flipTimerRef = useRef(null);
  const revealStartedForRef = useRef(null);
  const [shownCard1, setShownCard1] = useState(1);
  const [shownCard2, setShownCard2] = useState(1);
  const [shownCard3, setShownCard3] = useState(1);
  const [shownCard4, setShownCard4] = useState(1);
  const [shownCard5, setShownCard5] = useState(1);
  const [shownCard6, setShownCard6] = useState(1);
  const [shownCard7, setShownCard7] = useState(1);
  const [cardsSettled, setCardsSettled] = useState(false);
  const cardsSettleTimerRef = useRef(null);

  /* ================= SOCKET ================= */
  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "casino_war"
  });

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };
  const payload = data?.data?.data;
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  //console.log("data:", payload); // DO NOT REMOVE

  const payloadResult = data?.data?.result;
  //console.log("payloadResult:", payloadResult); // DO NOT REMOVE
  /* ================= TIMER + VALUES ================= */
  useEffect(() => {
    if (!payload) return;

    setDisplayLoader(false);
    updateUserData(data?.user);
    if (lastStatus !== payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]);
      setCard1Book({ back: 0, lay: 0 });
      setCard2Book({ back: 0, lay: 0 });
      setCard3Book({ back: 0, lay: 0 });
      setCard4Book({ back: 0, lay: 0 });
      setCard5Book({ back: 0, lay: 0 });
      setCard6Book({ back: 0, lay: 0 });
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
    }

    if (lastStatus !== payload.evt_status) {
      setLastStatus(payload.evt_status);
    }

    setRoundId(payload?.cat_mid);
    setB1Val(payload?.b1);
    setB2Val(payload?.b2);
    setB3Val(payload?.b3);
    setB4Val(payload?.b4);
    setB5Val(payload?.b5);
    setB6Val(payload?.b6);
    setCardDesc(payload?.cards_desc);
    setResultDesc(payload?.result_desc);

    if (payload?.cards_desc !== "") {
      let descArr = payload?.cards_desc.split(",");
      if (descArr.length > 0) {
        for (let i = 0; i < descArr.length; i++) {
          if (i == 0) {
            setCard1Value(descArr[0]);
          }
          if (i == 1) {
            setCard2Value(descArr[1]);
          }
          if (i == 2) {
            setCard3Value(descArr[2]);
          }

          if (i == 3) {
            setCard4Value(descArr[3]);
          }
          if (i == 4) {
            setCard5Value(descArr[4]);
          }

          if (i == 5) {
            setCard6Value(descArr[5]);
          }

          if (i == 6) {
            setCard7Value(descArr[6]);
          }
        }
      }
    }

    setResult(payload?.result);

    if (payload?.result == 2) {
      let resultDesc = payload?.result_desc.split(",");
      if (resultDesc.length > 0) {
        for (let i = 0; i < resultDesc.length; i++) {
          if (i == 0) {
            if (resultDesc[0] !== "0") {
              setCard1Winner(true);
            } else {
              setCard1Winner(false);
            }
          }

          if (i == 1) {
            if (resultDesc[1] !== "0") {
              setCard2Winner(true);
            } else {
              setCard2Winner(false);
            }
          }

          if (i == 2) {
            if (resultDesc[2] !== "0") {
              setCard3Winner(true);
            } else {
              setCard3Winner(false);
            }
          }

          if (i == 3) {
            if (resultDesc[3] !== "0") {
              setCard4Winner(true);
            } else {
              setCard4Winner(false);
            }
          }

          if (i == 4) {
            if (resultDesc[4] !== "0") {
              setCard5Winner(true);
            } else {
              setCard5Winner(false);
            }
          }

          if (i == 5) {
            if (resultDesc[5] !== "0") {
              setCard6Winner(true);
            } else {
              setCard6Winner(false);
            }
          }
        }
      }
    } else {
      setCard1Winner(false);
      setCard2Winner(false);
      setCard3Winner(false);
      setCard4Winner(false);
      setCard5Winner(false);
      setCard6Winner(false);
    }

    const serverSeconds = payload?.left_time;
    if (typeof serverSeconds === "number") {
      setTimeLeft(serverSeconds);
    }

    clearInterval(localTimerRef.current);
    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload]);

  useEffect(() => {
    /*if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      const latest10 = payloadResult.slice(-10).reverse();
      setResultList(payloadResult);
    }*/
    if (!payloadResult || payloadResult === "") return;
    const valuesArray = Object.values(payloadResult);
    const latest10 = valuesArray.slice(-10).reverse();

    setResultList(latest10);
  }, [payloadResult]);

  useEffect(() => () => clearInterval(localTimerRef.current), []);
  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };
  /* ================= SEQUENTIAL CARD REVEAL ================= */
  useEffect(() => {
    if (!payload?.evt_status) return;

    if (payload.evt_status === "OPEN") {
      clearTimeout(flipTimerRef.current);
      revealStartedForRef.current = null;
      setShownCard1(1);
      setShownCard2(1);
      setShownCard3(1);
      setShownCard4(1);
      setShownCard5(1);
      setShownCard6(1);
      setShownCard7(1);
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
      return;
    }

    if (payload.evt_status === "CLOSED") {
      const raw = payload?.cards_desc;
      // Wait until cards_desc actually arrives (may be empty on first CLOSED message)
      if (!raw || raw === "") return;
      // Only start the reveal once per unique cards_desc value
      if (revealStartedForRef.current === raw) return;
      revealStartedForRef.current = raw;

      clearTimeout(flipTimerRef.current);
      const cards = raw.split(",");

      setShownCard1(1);
      setShownCard2(1);
      setShownCard3(1);
      setShownCard4(1);
      setShownCard5(1);
      setShownCard6(1);
      setShownCard7(1);

      const setters = [
        setShownCard1,
        setShownCard2,
        setShownCard3,
        setShownCard4,
        setShownCard5,
        setShownCard6,
        setShownCard7
      ];

      let pos = 0;
      let cancelled = false;

      function revealNext() {
        if (cancelled || pos >= cards.length) return;
        setters[pos](cards[pos]);
        pos++;
        if (pos < cards.length) {
          flipTimerRef.current = setTimeout(revealNext, 1000);
        }
      }

      flipTimerRef.current = setTimeout(revealNext, 300);

      return () => {
        cancelled = true;
        clearTimeout(flipTimerRef.current);
      };
    }
  }, [payload?.evt_status, payload?.cards_desc]);

  useEffect(() => {
    const cards = cardDesc ? cardDesc.split(",") : [];
    const shownList = [
      shownCard1,
      shownCard2,
      shownCard3,
      shownCard4,
      shownCard5,
      shownCard6,
      shownCard7
    ];
    const allRevealed =
      cards.length > 0 &&
      cards.every(
        (card, i) => shownList[i] !== 1 && String(shownList[i]) === String(card)
      );

    if (!allRevealed) {
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
      return;
    }

    clearTimeout(cardsSettleTimerRef.current);
    cardsSettleTimerRef.current = setTimeout(() => {
      setCardsSettled(true);
    }, 1000);

    return () => clearTimeout(cardsSettleTimerRef.current);
  }, [
    cardDesc,
    shownCard1,
    shownCard2,
    shownCard3,
    shownCard4,
    shownCard5,
    shownCard6,
    shownCard7
  ]);

  useEffect(
    () => () => {
      clearTimeout(flipTimerRef.current);
      clearTimeout(cardsSettleTimerRef.current);
    },
    []
  );

  /* ================= SVG TIMER ================= */
  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  /* ================= BET SLIP ================= */
  const showBetfairBetSlip = (
    bettype,
    teamname,
    selectRnr,
    price,
    marketTypeVal,
    sid
  ) => {
    let obj = {
      amount: 0,
      catmid: payload?.cat_mid,
      round: payload?.cat_mid,
      odds: price,
      teamname,
      bettype,
      selectRnr,
      marketVal: 1,
      game_type: 7,
      game_name: "casinowar_virtual",
      market_type: marketTypeVal,
      sid: sid
    };

    setPlaceBetObject(obj);
    //console.log("isMobile: ", isMobile);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
  };

  const closeBetSlip = () => setShowBetSlip(false);

  const [profileData, setProfileData] = useState(null);
  const [placedBets, setPlacedBets] = useState([]);
  const [initialBetsFetched, setInitialBetsFetched] = useState(false);

  const fetchProfile = async () => {
    const { data } = await axiosInstance.get("/profile");
    setProfileData(data);
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.cat_mid,
      gametype: "casinowar_virtual"
    });
    setPlacedBets(res.data);
  }

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  useEffect(() => {
    if (!initialBetsFetched && payload?.cat_mid) {
      getPlacedBets();
      getBook();
      setInitialBetsFetched(true);
    }
  }, [payload]);

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;
    // placeBetObject.sid1 = payload?.sid1;
    // placeBetObject.sid2 = payload?.sid2;
    // placeBetObject.sid3 = payload?.sid3;

    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
          setShowBetSlipPopup(false);
          getPlacedBets();
          getBook();
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  async function getBook() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "casinowar_virtual"
    });
    let books = res?.data;
    if (books !== null && books.length > 0) {
      for (let i = 0; i < books.length; i++) {
        let obj = books[i];
        if (obj.rnr == "Player1") {
          setCard1Book({ back: obj.back, lay: obj.lay });
        } else if (obj.rnr == "Player2") {
          setCard2Book({ back: obj.back, lay: obj.lay });
        } else if (obj.rnr == "Player3") {
          setCard3Book({ back: obj.back, lay: obj.lay });
        } else if (obj.rnr == "Player4") {
          setCard4Book({ back: obj.back, lay: obj.lay });
        } else if (obj.rnr == "Player5") {
          setCard5Book({ back: obj.back, lay: obj.lay });
        } else if (obj.rnr == "Player6") {
          setCard6Book({ back: obj.back, lay: obj.lay });
        }
      }
    }
  }

  const displayRunnerName = (runnerName) => {
    let runnerNameTxt = "";
    if (runnerName == "b1") {
      runnerNameTxt = "Player 1";
    } else if (runnerName == "b2") {
      runnerNameTxt = "Player 2";
    } else if (runnerName == "b3") {
      runnerNameTxt = "Player 3";
    } else if (runnerName == "b4") {
      runnerNameTxt = "Player 4";
    } else if (runnerName == "b5") {
      runnerNameTxt = "Player 5";
    } else if (runnerName == "b6") {
      runnerNameTxt = "Player 6";
    }
    return runnerNameTxt
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const getResultValue = (value) => {
    let returnTxt = "";
    if (value === 1) {
      returnTxt = "D";
    } else if (value === 2) {
      returnTxt = "R";
    } else {
      returnTxt = "T";
    }
    return returnTxt;
  };

  /// result detail ///
  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "casinowar_virtual";

    const response = await axiosInstance.post("/teenpatti-results", resultObj);

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };
  /// result detail ///

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  const isMobile = window.innerWidth <= 768;
  //console.log("resultList:", resultList);

  return (
    <div className="casinowar-scope aviator-scope player-scope aviator-bg-black">
      <ClientLayoutWithOutHeader showLoader={false}>
        <div class="details-tabs-wrapper1">
          <div className="main-page">
            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="bodyheight">
                  <div className="wrapper">
                    <TPStudioSidebar open={open} />
                  </div>

                  <div className="lobby-ctn BPGmaindiv">
                    <TpStudioHeader setOpen={setOpen} open={open} />
                    <TpStudioLoader displayLoader={displayLoader} />
                  </div>

                  <div
                    className="row"
                    style={{
                      display: displayLoader ? "none" : "",
                      paddingLeft: "5px"
                    }}
                  >
                    <div className="col-md-8">
                      <div className="left-content">
                        <div className="cards-layout blackjack">
                          <div>
                            <div className="cards-layout blackjack">
                              <div
                                className="col-12 timerDiv2"
                                style={{ paddingLeft: "0px" }}
                              >
                                <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                                  <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                                    <p>CASINO WAR</p>
                                  </div>
                                  <div
                                    className="col-6 col-md-6 inline-block Gameidcol text-right"
                                    style={{ marginTop: "4px" }}
                                  >
                                    <div
                                      role="group"
                                      aria-label="Second group"
                                      className="btn-group btn-group-sm mr-2"
                                    >
                                      <button
                                        style={{ fontSize: "14px" }}
                                        type="button"
                                        id="Alltab"
                                        className={
                                          activeTabIndex == 1
                                            ? "tablink btn btn-primary bbactive"
                                            : "tablink btn btn-primary"
                                        }
                                        onClick={() => activeTab(1)}
                                      >
                                        Game
                                      </button>
                                      <button
                                        style={{ fontSize: "14px" }}
                                        type="button"
                                        id="RESULTStab"
                                        className={
                                          activeTabIndex == 2
                                            ? "tablink btn btn-primary bbactive"
                                            : "tablink btn btn-primary"
                                        }
                                        onClick={() => activeTab(2)}
                                      >
                                        Results
                                      </button>
                                      <button
                                        style={{ fontSize: "14px" }}
                                        type="button"
                                        className="tablink btn btn-primary"
                                        onClick={() => setShowRules(true)}
                                      >
                                        Rules
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <CasinoWRules
                                show={showRules}
                                onClose={() => setShowRules(false)}
                              />

                              <div
                                className="row mt-2"
                                style={{
                                  display: activeTabIndex == 1 ? "" : "none",
                                  justifyContent: "space-between",
                                  alignItems: "center"
                                }}
                              >
                                <div className="col-2 col-md-1">
                                  <div className="Connectedclients mt-1">
                                    <i
                                      aria-hidden="true"
                                      className="fa fa-user mr-1"
                                      style={{
                                        fontSize: "14px",
                                        color: "white"
                                      }}
                                    />
                                    <b>
                                      <span id="UsersCount" className="number">
                                        326
                                      </span>
                                    </b>
                                  </div>
                                </div>

                                <div
                                  className="col-md-8"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                />
                                <div
                                  className="col-md-2"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  <div class="casino-timer">
                                    <svg
                                      class="progressBar"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 80 80"
                                    >
                                      <path
                                        class="track track_red"
                                        d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                                      ></path>
                                      <path
                                        class="fill fill_red"
                                        d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                                        style={{
                                          strokeCashoffset:
                                            "-219.99078369140625"
                                        }}
                                      ></path>
                                      <text class="value" x="50%" y="55%">
                                        {timeLeft == 1 ? 0 : timeLeft}
                                      </text>
                                    </svg>
                                  </div>
                                </div>
                              </div>

                              <span
                                style={{
                                  opacity: 1,
                                  display: activeTabIndex == 1 ? "" : "none"
                                }}
                              >
                                <div
                                  id="videos"
                                  class="collapse show"
                                  aria-labelledby="headingThree"
                                  data-parent="#video"
                                  style={{
                                    textAlign: "center",
                                    padding: "0px",
                                    minHeight: "160px",
                                    position: "relative",
                                    marginTop: "10px"
                                  }}
                                >
                                  <div class="player-containerHC">
                                    <div class="player-itemHC">
                                      <span class="player-nameHC">
                                        Player 1
                                      </span>
                                      <div class="player-cardHC">
                                        <div
                                          id="BFBCardFanView"
                                          class="card-viewHC card1"
                                        >
                                          <div class="header-title">
                                            <span class="status"></span>
                                          </div>
                                          <div
                                            id="BFBCardHandView"
                                            class="BFBCardHandView"
                                          >
                                            <div
                                              id="game-cards1"
                                              class="BFBCardFanView"
                                            >
                                              {shownCard1 &&
                                                (() => {
                                                  let resultCardImage = `../assets/cards3/${shownCard1}.svg`;
                                                  return (
                                                    <img
                                                      src={resultCardImage}
                                                      alt="Card Image"
                                                      class="RSMImageView animate__animated animate__flipInY"
                                                    />
                                                  );
                                                })()}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="player-containerHC">
                                    <div class="player-itemHC">
                                      <span class="player-nameHC">
                                        Player 2
                                      </span>
                                      <div class="player-cardHC">
                                        <div
                                          id="BFBCardFanView"
                                          class="card-viewHC card1"
                                        >
                                          <div class="header-title">
                                            <span class="status"></span>
                                          </div>
                                          <div
                                            id="BFBCardHandView"
                                            class="BFBCardHandView"
                                          >
                                            <div
                                              id="game-cards1"
                                              class="BFBCardFanView"
                                            >
                                              {shownCard2 &&
                                                (() => {
                                                  let resultCardImage = `../assets/cards3/${shownCard2}.svg`;
                                                  return (
                                                    <img
                                                      src={resultCardImage}
                                                      alt="Card Image"
                                                      class="RSMImageView animate__animated animate__flipInY"
                                                    />
                                                  );
                                                })()}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="player-containerHC">
                                    <div class="player-itemHC">
                                      <span class="player-nameHC">
                                        Player 3
                                      </span>
                                      <div class="player-cardHC">
                                        <div
                                          id="BFBCardFanView"
                                          class="card-viewHC card1"
                                        >
                                          <div class="header-title">
                                            <span class="status"></span>
                                          </div>
                                          <div
                                            id="BFBCardHandView"
                                            class="BFBCardHandView"
                                          >
                                            <div
                                              id="game-cards1"
                                              class="BFBCardFanView"
                                            >
                                              {shownCard3 &&
                                                (() => {
                                                  let resultCardImage = `../assets/cards3/${shownCard3}.svg`;
                                                  return (
                                                    <img
                                                      src={resultCardImage}
                                                      alt="Card Image"
                                                      class="RSMImageView animate__animated animate__flipInY"
                                                    />
                                                  );
                                                })()}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="player-containerHC">
                                    <div class="player-itemHC">
                                      <span class="player-nameHC">
                                        Player 4
                                      </span>
                                      <div class="player-cardHC">
                                        <div
                                          id="BFBCardFanView"
                                          class="card-viewHC card1"
                                        >
                                          <div class="header-title">
                                            <span class="status"></span>
                                          </div>
                                          <div
                                            id="BFBCardHandView"
                                            class="BFBCardHandView"
                                          >
                                            <div
                                              id="game-cards1"
                                              class="BFBCardFanView"
                                            >
                                              {shownCard4 &&
                                                (() => {
                                                  let resultCardImage = `../assets/cards3/${shownCard4}.svg`;
                                                  return (
                                                    <img
                                                      src={resultCardImage}
                                                      alt="Card Image"
                                                      class="RSMImageView animate__animated animate__flipInY"
                                                    />
                                                  );
                                                })()}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="player-containerHC">
                                    <div class="player-itemHC">
                                      <span class="player-nameHC">
                                        Player 5
                                      </span>
                                      <div class="player-cardHC">
                                        <div
                                          id="BFBCardFanView"
                                          class="card-viewHC card1"
                                        >
                                          <div class="header-title">
                                            <span class="status"></span>
                                          </div>
                                          <div
                                            id="BFBCardHandView"
                                            class="BFBCardHandView"
                                          >
                                            <div
                                              id="game-cards1"
                                              class="BFBCardFanView"
                                            >
                                              {shownCard5 &&
                                                (() => {
                                                  let resultCardImage = `../assets/cards3/${shownCard5}.svg`;
                                                  return (
                                                    <img
                                                      src={resultCardImage}
                                                      alt="Card Image"
                                                      class="RSMImageView animate__animated animate__flipInY"
                                                    />
                                                  );
                                                })()}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="player-containerHC">
                                    <div class="player-itemHC">
                                      <span class="player-nameHC">
                                        Player 6
                                      </span>
                                      <div class="player-cardHC">
                                        <div
                                          id="BFBCardFanView"
                                          class="card-viewHC card1"
                                        >
                                          <div class="header-title">
                                            <span class="status"></span>
                                          </div>
                                          <div
                                            id="BFBCardHandView"
                                            class="BFBCardHandView"
                                          >
                                            <div
                                              id="game-cards1"
                                              class="BFBCardFanView"
                                            >
                                              {shownCard6 &&
                                                (() => {
                                                  let resultCardImage = `../assets/cards3/${shownCard6}.svg`;
                                                  return (
                                                    <img
                                                      src={resultCardImage}
                                                      alt="Card Image"
                                                      class="RSMImageView animate__animated animate__flipInY"
                                                    />
                                                  );
                                                })()}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="player-containerHC">
                                    <div class="player-itemHC">
                                      <span class="player-nameHC">Dealer</span>
                                      <div
                                        class="player-cardHC"
                                        style={{ border: "3px solid red" }}
                                      >
                                        <div
                                          id="BFBCardFanView"
                                          class="card-viewHC card1"
                                        >
                                          <div class="header-title">
                                            <span class="status"></span>
                                          </div>
                                          <div
                                            id="BFBCardHandView"
                                            class="BFBCardHandView"
                                          >
                                            <div
                                              id="game-cards1"
                                              class="BFBCardFanView"
                                            >
                                              {shownCard7 &&
                                                (() => {
                                                  let resultCardImage = `../assets/cards3/${shownCard7}.svg`;
                                                  return (
                                                    <img
                                                      src={resultCardImage}
                                                      alt="Card Image"
                                                      class="RSMImageView animate__animated animate__flipInY"
                                                    />
                                                  );
                                                })()}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <Volume
                                    id="CasinoWarSoundcontrol"
                                    style={{
                                      position: "absolute",
                                      right: 8,
                                      bottom: 8,
                                      zIndex: 100
                                    }}
                                  />
                                </div>
                              </span>

                              {/* Controls removed (auto mode) */}
                            </div>
                          </div>
                        </div>

                        {/* Footer */}
                        <div
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                            <div className="buttons-div">
                              {Object.keys(resultList)
                                .slice(
                                  0,
                                  isMobile ? 5 : Object.keys(resultList).length
                                )
                                .map((idx) => (
                                  <button
                                    key={idx}
                                    className="video-button border-gradient-btn border-gradient-purple-btn"
                                  >
                                    {resultList[idx]}
                                  </button>
                                ))}
                            </div>
                            <div className="round-div">
                              <div className="label">Round ID:</div>
                              <div className="id">{roundId}</div>
                            </div>
                          </div>
                        </div>

                        {/* Market Sections (unchanged) */}
                        <div
                          className="bg-white"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div
                            className="tb-content"
                            style={{ background: "#fff" }}
                          >
                            <div className="market-titlebar">
                              <p className="market-name">
                                <span className="market-name-badge">
                                  <i className="market-name-icon">
                                    <img
                                      src="/assets/images/time-img.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px"
                                      }}
                                    />
                                  </i>
                                  <span>MAIN </span>
                                </span>
                              </p>
                              <div className="market-overarround">
                                <span />
                                <strong>Back</strong>
                              </div>
                              <div className="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>
                            <div className="market-runners">
                              <div className="runner-runner">
                                <h3
                                  className={
                                    card1Winner && cardsSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                >
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                Player 1
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                style={{
                                                  float: "left",
                                                  color: "green",
                                                  fontWeight: 600,
                                                  display:
                                                    card1Book.back != 0
                                                      ? ""
                                                      : "none"
                                                }}
                                              >
                                                {formatTruncate(card1Book.back)}
                                              </div>
                                              <div
                                                style={{
                                                  float: "left",
                                                  color: "red",
                                                  fontWeight: 600,
                                                  display:
                                                    card1Book.lay != 0
                                                      ? ""
                                                      : "none"
                                                }}
                                              >
                                                /{formatTruncate(card1Book.lay)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div
                                      className="runner-disabled2"
                                      id="suspendCls1"
                                    >
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    data-teamname="Amar"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "Player 1",
                                        "Player 1",
                                        b1Val,
                                        "m",
                                        1
                                      )
                                    }
                                  >
                                    {b1Val}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div className="runner-runner">
                                <h3
                                  className={
                                    card2Winner && cardsSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                >
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                Player 2
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                style={{
                                                  float: "left",
                                                  color: "green",
                                                  fontWeight: 600,
                                                  display:
                                                    card2Book.back != 0
                                                      ? ""
                                                      : "none"
                                                }}
                                              >
                                                {formatTruncate(card2Book.back)}
                                              </div>
                                              <div
                                                style={{
                                                  float: "left",
                                                  color: "red",
                                                  fontWeight: 600,
                                                  display:
                                                    card2Book.lay != 0
                                                      ? ""
                                                      : "none"
                                                }}
                                              >
                                                /{formatTruncate(card2Book.lay)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div
                                      className="runner-disabled2"
                                      id="suspendCls1"
                                    >
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b2span"
                                    data-teamname="Akbar"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "Player 2",
                                        "Player 2",
                                        b2Val,
                                        "m",
                                        2
                                      )
                                    }
                                  >
                                    {b2Val}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div className="runner-runner">
                                <h3
                                  className={
                                    card3Winner && cardsSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                >
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                Player 3
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                style={{
                                                  float: "left",
                                                  color: "green",
                                                  fontWeight: 600,
                                                  display:
                                                    card3Book.back != 0
                                                      ? ""
                                                      : "none"
                                                }}
                                              >
                                                {formatTruncate(card3Book.back)}
                                              </div>
                                              <div
                                                style={{
                                                  float: "left",
                                                  color: "red",
                                                  fontWeight: 600,
                                                  display:
                                                    card3Book.lay != 0
                                                      ? ""
                                                      : "none"
                                                }}
                                              >
                                                /{formatTruncate(card3Book.lay)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div
                                      className="runner-disabled2"
                                      id="suspendCls1"
                                    >
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b2span"
                                    data-teamname="Player3"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "Player 3",
                                        "Player 3",
                                        b3Val,
                                        "m",
                                        3
                                      )
                                    }
                                  >
                                    {b3Val}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div className="runner-runner">
                                <h3
                                  className={
                                    card4Winner && cardsSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                >
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                Player 4
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                style={{
                                                  float: "left",
                                                  color: "green",
                                                  fontWeight: 600,
                                                  display:
                                                    card4Book.back != 0
                                                      ? ""
                                                      : "none"
                                                }}
                                              >
                                                {formatTruncate(card4Book.back)}
                                              </div>
                                              <div
                                                style={{
                                                  float: "left",
                                                  color: "red",
                                                  fontWeight: 600,
                                                  display:
                                                    card4Book.lay != 0
                                                      ? ""
                                                      : "none"
                                                }}
                                              >
                                                /{formatTruncate(card4Book.lay)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div
                                      className="runner-disabled2"
                                      id="suspendCls1"
                                    >
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b2span"
                                    data-teamname="Player4"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "Player 4",
                                        "Player 4",
                                        b4Val,
                                        "m",
                                        3
                                      )
                                    }
                                  >
                                    {b4Val}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div className="runner-runner">
                                <h3
                                  className={
                                    card5Winner && cardsSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                >
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                Player 5
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                style={{
                                                  float: "left",
                                                  color: "green",
                                                  fontWeight: 600,
                                                  display:
                                                    card5Book.back != 0
                                                      ? ""
                                                      : "none"
                                                }}
                                              >
                                                {formatTruncate(card5Book.back)}
                                              </div>
                                              <div
                                                style={{
                                                  float: "left",
                                                  color: "red",
                                                  fontWeight: 600,
                                                  display:
                                                    card5Book.lay != 0
                                                      ? ""
                                                      : "none"
                                                }}
                                              >
                                                /{" "}
                                                {formatTruncate(card5Book.lay)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div
                                      className="runner-disabled2"
                                      id="suspendCls1"
                                    >
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b2span"
                                    data-teamname="Player5"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "Player 5",
                                        "Player 5",
                                        b5Val,
                                        "m",
                                        3
                                      )
                                    }
                                  >
                                    {b5Val}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div className="runner-runner">
                                <h3
                                  className={
                                    card6Winner && cardsSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                >
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                Player 6
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                style={{
                                                  float: "left",
                                                  color: "green",
                                                  fontWeight: 600,
                                                  display:
                                                    card6Book.back != 0
                                                      ? ""
                                                      : "none"
                                                }}
                                              >
                                                {formatTruncate(card6Book.back)}
                                              </div>
                                              <div
                                                style={{
                                                  float: "left",
                                                  color: "red",
                                                  fontWeight: 600,
                                                  display:
                                                    card6Book.lay != 0
                                                      ? ""
                                                      : "none"
                                                }}
                                              >
                                                /{formatTruncate(card6Book.lay)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div
                                      className="runner-disabled2"
                                      id="suspendCls1"
                                    >
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b2span"
                                    data-teamname="Player6"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "Player 6",
                                        "Player 6",
                                        b6Val,
                                        "m",
                                        3
                                      )
                                    }
                                  >
                                    {b6Val}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: activeTabIndex == 2 ? "" : "none",
                          color: "white"
                        }}
                      >
                        <CasinoWarResult resultData={resultData} />
                      </div>
                    </div>

                    <div className="col-md-4">
                      {showBetSlipPopup && (
                        <TPPopUpBetSlip
                          closeBetSlipParent={closeBetSlipMobile}
                          betObj={placeBetObject}
                          placeBetParent={placeBet}
                          betButtonShow={betButtonShow}
                          betErrorMessageObj={betErrorMessageObj}
                          betButtonShowLoaderShow={betButtonShowLoaderShow}
                          profileData={profileData}
                        />
                      )}

                      <TeenPattisCasinoBetslipWeb
                        showBetSlip={showBetSlip}
                        placeBetObject={placeBetObject}
                        closeBetSlipParent={closeBetSlip}
                        placeBetParent={placeBet}
                        betErrorMessageObj={betErrorMessageObj}
                        profileData={profileData}
                      ></TeenPattisCasinoBetslipWeb>
                      <div>
                        <div className="bets">
                          <strong>
                            Matched Bets (0)
                            <img
                              src={reconnecting}
                              alt="dc"
                              className="rounded disconnected"
                              style={{ display: "none" }}
                            />{" "}
                          </strong>
                          <div className="betting-table">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Runner</th>
                                  <th>Price</th>
                                  <th>Size</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {placedBets.map((bet, index) => {
                                  console.log("MATCHED BET:", bet);

                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        background:
                                          bet.type == "b"
                                            ? "#e9f6fc"
                                            : "#fce3e4"
                                      }}
                                    >
                                      <td>
                                        {displayRunnerName(bet.rnr)} - (
                                        {bet.cat_mid})
                                      </td>

                                      <td>{bet.amnt}</td>
                                      <td>{bet.rate}</td>
                                      <td></td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <style>
            {`

        
@scope (.casinowar-scope) {
    @media (max-width: 768px) {
        .video-button:nth-last-child(-n+5) {
            display: inline-flex;
        }
    }
}
                .casinowar-scope .player {
                     
                    display: inline-block;
                    justify-content: space-between;
                    flex: 1 0 0;
                    flex-wrap: wrap;
                }

                .casinowar-scope .player-item {
                    margin-bottom: 16px;
                    display: block;
                    margin-right: 0;
                    z-index: 0;
                }
                .casinowar-scope .player-item .name {
                    display: block;
                    color: #d7bc7b;
                    font-size: 14px;
                    font-weight: 700;
                    padding-bottom: 5px;
                    text-align: center;
                }
                .casinowar-scope .player-item .player-card {
                    border-radius: 12px;
                    border: 1px solid rgba(178, 220, 175, .25);
                }
                .casinowar-scope .BFBCardHandView {
                    transform: translate3d(0, 0, 0); 
                    width: 80px;
                    height: 96px;
                    margin-top: 0px;
                    margin-bottom: 0px;
                }
                .casinowar-scope .casino-timer {
                    position: absolute;
                    right: 25px;
                    top: 0px;
                    display: flex;
                    display: -webkit-flex;
                    border-radius: 50px;
                    background-color: transparent;
                }
                .casinowar-scope .progressBar{
                    width: 50px;
                    height: 50px;
                    z-index: 1;
                    background-color: transparent;
                }
                .casinowar-scope .BFBCardFanView{
                    padding: 15px;
                }
                
                @media (max-width:576px){
                  .casinowar-scope .col-md-4
                  {
                    margin-top: 10px;
                  }
                }
                `}
          </style>
        </div>
      </ClientLayoutWithOutHeader>
      <style>
        {`.casinowar-scope .home-content {
              margin-top: 0 !important;
            }
            .casinowar-scope .BFBCardFanView {
              padding: 0;
            }
            .casinowar-scope .cards-layout.blackjack {
              position: relative;
              background: #000000;
            }
            .casinowar-scope .cards-layout.blackjack::before {
              content: "";
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              background: radial-gradient(
                ellipse 100% 44% at 50% calc(30% + 60px),
                rgba(62, 193, 65, 0.95) 0%,
                rgba(62, 193, 65, 0.8) 15%,
                rgba(30, 80, 35, 0.5) 40%,
                #1e1e1e 55%,
                #1e1e1e 100%
              );
              opacity: 0.4;
              pointer-events: none;
              z-index: 0;
            }
            .casinowar-scope .cards-layout.blackjack > * {
              position: relative;
              z-index: 1;
            }
            .casinowar-scope .cards-layout.blackjack > .timerDiv2,
            .casinowar-scope .cards-layout.blackjack > .row.mt-2 {
              position: relative;
              z-index: 10;
            }
            .casinowar-scope .cards-layout.blackjack .sound-icon {
              right: 18px !important;
              transform: scale(0.9);
              transform-origin: center;
            }
            .casinowar-scope .Connectedclients {
              margin-left: 10px;
            }
            `}
      </style>
    </div>
  );
}
